module.exports = __webpack_public_path__ + "static/media/heart.1ca8758a.svg";